<template>
    <svg
        id="whatsapp"
        xmlns="http://www.w3.org/2000/svg"
        width="23.166"
        height="23.166"
        viewBox="726.417 298.277 23.166 23.166"
    >
        <g data-name="whatsapp-svgrepo-com-6">
            <path
                d="M738.004 298.277h-.007c-6.386 0-11.58 5.195-11.58 11.583 0 2.533.818 4.882 2.206 6.79l-1.443 4.303 4.452-1.423a11.491 11.491 0 0 0 6.372 1.913c6.385 0 11.579-5.196 11.579-11.583 0-6.387-5.194-11.583-11.58-11.583Zm6.739 16.357c-.279.79-1.389 1.443-2.273 1.634-.607.13-1.396.232-4.058-.872-3.404-1.41-5.596-4.868-5.766-5.094-.164-.224-1.375-1.831-1.375-3.493 0-1.661.844-2.472 1.184-2.82.28-.285.743-.414 1.185-.414.143 0 .272.007.388.013.34.014.51.035.735.572.28.674.96 2.336 1.042 2.506.081.17.163.402.047.626-.109.232-.204.335-.374.532s-.334.347-.504.558c-.156.184-.334.382-.136.722.198.334.878 1.444 1.879 2.335 1.293 1.151 2.342 1.52 2.716 1.676.279.116.613.088.817-.13.259-.279.58-.742.906-1.198.231-.327.524-.368.83-.252.314.108 1.968.926 2.309 1.096.34.17.564.252.646.395.081.144.081.818-.198 1.608Z"
                fill="#25d366"
                fill-rule="evenodd"
                data-name="Path 345"
            />
            <path
                d="M726.417 309.86c0 2.533.818 4.882 2.206 6.79l-1.443 4.303 4.452-1.423a11.491 11.491 0 0 0 6.372 1.913c6.385 0 11.579-5.196 11.579-11.583 0-6.387-5.194-11.583-11.58-11.583h-.006m6.746 16.357c-.279.79-1.389 1.443-2.273 1.634-.607.13-1.396.232-4.058-.872-3.404-1.41-5.596-4.868-5.766-5.094-.164-.224-1.375-1.831-1.375-3.493 0-1.661.844-2.472 1.184-2.82.28-.285.743-.414 1.185-.414.143 0 .272.007.388.013.34.014.51.035.735.572.28.674.96 2.336 1.042 2.506.081.17.163.402.047.626-.109.232-.204.335-.374.532s-.334.347-.504.558c-.156.184-.334.382-.136.722.198.334.878 1.444 1.879 2.335 1.293 1.151 2.342 1.52 2.716 1.676.279.116.613.088.817-.13.259-.279.58-.742.906-1.198.231-.327.524-.368.83-.252.314.108 1.968.926 2.309 1.096.34.17.564.252.646.395.081.144.081.818-.198 1.608Z"
                fill="#25d366"
                fill-rule="evenodd"
                data-name="Path 346"
            />
            <g data-name="Group 174">
                <path
                    d="M741.707 298.888c2.953 2.525 4.88 6.384 4.88 9.651 0 1.8-.585 3.483-1.604 4.93a4.13 4.13 0 0 1-.24 1.165c-.279.79-1.39 1.443-2.274 1.634a3.08 3.08 0 0 1-.566.074c-1.939 1.21-4.341 1.925-6.944 1.925-2.343 0-4.523-.582-6.35-1.58l-1.429 4.266 4.452-1.423a11.491 11.491 0 0 0 6.372 1.913c6.385 0 11.579-5.196 11.579-11.583 0-5.092-3.302-9.423-7.876-10.972Z"
                    fill="#25d366"
                    fill-rule="evenodd"
                    data-name="Path 347"
                />
                <path
                    d="M741.986 311.535c.077.027.236.097.436.19l-7.74-7.74c.027.05.054.11.081.176.28.673.96 2.335 1.042 2.505.081.17.163.402.047.627-.109.231-.204.334-.374.531s-.334.348-.504.559c-.156.183-.334.381-.136.721.198.335.878 1.444 1.879 2.336 1.293 1.15 2.342 1.519 2.716 1.675.279.116.613.088.817-.13.259-.279.58-.741.906-1.197.23-.328.524-.368.83-.253Z"
                    fill="#25d366"
                    fill-rule="evenodd"
                    data-name="Path 348"
                />
            </g>
            <path
                d="m731.271 306.82-.076.076.083.083c-.003-.053-.007-.106-.007-.16Z"
                fill="#25d366"
                fill-rule="evenodd"
                data-name="Path 349"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Whatsapp",
};
</script>
